/*
  1 - 封面图
  2 - 身份证明
  3 - 举报
  4 - 微信二维码
  5 - 学历证明
  6 - 公司证明
  7 - 工作证
  8 - 头像
*/
export const UPLOAD_TYPE = {
  cover: 1,
  identity: 2,
  report: 3,
  wxCode: 4,
  schooling: 5,
  company: 6,
  work: 7,
  head: 8
};

/* 
  终端类型
  H5:1
  小程序:2
*/
export const TERM_TYPE_H5 = 1